/**
 * @class CartRemoveButton
 * @description Web component para el botón de eliminar ítem del carrito.
 * Emite un evento para que cart-drawer procese la eliminación del producto.
 */
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.index = this.dataset.index;                // índice de línea en el carrito
    this.variantId = this.dataset.variantId;        // ID de la variante del producto
    this.productTitle = this.dataset.title;         // título del producto para notificaciones
    this.button = this.querySelector('button');     // botón de eliminar
    this.onRemoveButton = this.handleRemoveButton.bind(this);
  }

  /**
   * @method connectedCallback
   * @description Registra el listener para el click cuando el componente se añade al DOM
   */
  connectedCallback() {
    this.button.addEventListener('click', this.onRemoveButton);
  }

  /**
   * @method disconnectedCallback
   * @description Limpia el listener cuando el componente se elimina del DOM
   */
  disconnectedCallback() {
    this.button.removeEventListener('click', this.onRemoveButton);
  }

  /**
   * @method handleRemoveButton
   * @description Maneja el click en el botón de eliminar, preparando los datos
   * y emitiendo un evento para que cart-drawer elimine el ítem del carrito
   * @param {Event} event - Evento de click
   */
  handleRemoveButton(event) {
    // Cantidad 0 indica eliminar el ítem del carrito
    const quantity = 0;
    const variantId = this.variantId;
    const lineIndex = this.index;
    const productTitle = this.productTitle;
    const message = `${window.globalTranslations.removeToCart}`;

    // Programamos la emisión del evento con delay para evitar múltiples eventos
    this.updateTimeout = setTimeout(() => {
      // Emitimos evento con datos de cantidad y línea para que cart-drawer lo procese
      this.dispatchEvent(new CustomEvent('pb:quantity:updated', {
        detail: {quantity, variantId, lineIndex, productTitle, message}, 
        bubbles: true
      }));
    }, 500);
  }
}

customElements.define('cart-remove-button', CartRemoveButton);